<script>
import HeaderView from '../../../shared/views/HeaderView';
import MainMenuInstructorView from '../../../shared/views/MainMenuInstructorView';
import ListCoursesInstructorView from '../lists/ListCoursesInstructorView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';

export default {
  components: {
    'header-view': HeaderView,
    'main-menu-instructor-view': MainMenuInstructorView,
    'list-courses-view': ListCoursesInstructorView,
  },
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <header-view />
    <main-menu-instructor-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <h4 class="item_title">
                  <i class="uil uil-book" /> Todos los Cursos
                </h4>
                <div class="la5lo1">
                  <list-courses-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
